import React, { CSSProperties, FC, MouseEventHandler } from 'react';
import clsx from 'clsx';
import styles from './Carousel.module.css';
import leftPath from './leftPath';
import rightPath from './rightPath';

export enum ArrowPosition {
  ARROW_PREV = 'prev',
  ARROW_NEXT = 'next',
}

export interface SliderArrowProps {
  arrowPosition: ArrowPosition;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  defaultStyles?: CSSProperties;
  disabledStyles?: CSSProperties;
  activeStyles?: CSSProperties;
  containerStyles?: CSSProperties;
}

const DEFAULT_ARROW_FILL_COLOR = '#2C3239';

const SliderArrow: FC<SliderArrowProps> = ({
  arrowPosition,
  onClick,
  disabled = true,
}) => {
  const isArrowNext = arrowPosition === ArrowPosition.ARROW_NEXT;

  const classes = clsx({
    [styles.button]: true,
    [styles.buttonDisabled]: disabled,
  });

  const svgClasses = clsx({
    [styles.arrowSvg]: true,
    [styles.arrowSvgDisabled]: disabled,
  });

  return (
    <button className={classes} disabled={disabled} onClick={onClick}>
      <svg className={svgClasses} viewBox="-10 -9 32 32">
        <g fill="none" fillRule="evenodd">
          <path d={isArrowNext ? rightPath[0] : leftPath[0]} />
          <path
            fill={DEFAULT_ARROW_FILL_COLOR}
            d={isArrowNext ? rightPath[1] : leftPath[1]}
          />
        </g>
      </svg>
    </button>
  );
};

export default SliderArrow;
